import React, { useEffect, useState } from 'react';
import AdminLayout from './AdminLayout';
import api from '../../api';
import { useAdmin } from '../../context/AdminContext';

const blank = { title: '', category: 'Travel Tips', coverImage: '', excerpt: '', content: '' };
const categories = ['Travel Tips', 'Visa Updates', 'Destination Guides', 'Travel News', 'General'];

export default function AdminBlog() {
  const [posts, setPosts]       = useState([]);
  const [form, setForm]         = useState(blank);
  const [editingId, setEditingId] = useState(null);
  const [tab, setTab]           = useState('list'); // 'list' | 'form' — for mobile tab switching
  const [blogChecked, setBlogChecked] = useState([]);
  const { isSuperAdmin } = useAdmin();

  function load() {
    api.get('/blog?limit=100').then(function(res) { setPosts(res.data.posts); setBlogChecked([]); }).catch(function() {});
  }
  useEffect(function() { load(); }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    if (editingId) { await api.put('/blog/' + editingId, form); }
    else           { await api.post('/blog', form); }
    setForm(blank);
    setEditingId(null);
    setTab('list');
    load();
  }

  async function startEdit(id) {
    var post = posts.find(function(p) { return p._id === id; });
    var res  = await api.get('/blog/' + post.slug);
    setForm(res.data);
    setEditingId(id);
    setTab('form');
  }

  async function remove(id) {
    if (!window.confirm('Delete this post?')) return;
    await api.delete('/blog/' + id);
    load();
  }

  var formPanel = (
    <form onSubmit={handleSubmit} className="card" style={{ padding: 24 }}>
      <h3 style={{ marginBottom: 18 }}>{editingId ? 'Edit Post' : 'New Post'}</h3>
      <div className="form-field" style={{ marginBottom: 14 }}>
        <label>Title</label>
        <input required value={form.title} onChange={function(e) { setForm({ ...form, title: e.target.value }); }} />
      </div>
      <div className="form-field" style={{ marginBottom: 14 }}>
        <label>Category</label>
        <select value={form.category} onChange={function(e) { setForm({ ...form, category: e.target.value }); }}>
          {categories.map(function(c) { return <option key={c}>{c}</option>; })}
        </select>
      </div>
      <div className="form-field" style={{ marginBottom: 14 }}>
        <label>Cover Image URL</label>
        <input value={form.coverImage} onChange={function(e) { setForm({ ...form, coverImage: e.target.value }); }} placeholder="https://..." />
      </div>
      <div className="form-field" style={{ marginBottom: 14 }}>
        <label>Excerpt</label>
        <textarea rows={2} value={form.excerpt} onChange={function(e) { setForm({ ...form, excerpt: e.target.value }); }} />
      </div>
      <div className="form-field" style={{ marginBottom: 14 }}>
        <label>Content</label>
        <textarea rows={8} required value={form.content} onChange={function(e) { setForm({ ...form, content: e.target.value }); }} />
      </div>
      <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}>
        {editingId ? 'Update Post' : 'Publish Post'}
      </button>
      {editingId && (
        <button type="button" className="btn btn-outline" style={{ width: '100%', justifyContent: 'center', marginTop: 8 }}
          onClick={function() { setForm(blank); setEditingId(null); setTab('list'); }}>
          Cancel
        </button>
      )}
    </form>
  );

  var listPanel = (
    <div className="card" style={{ padding: 20 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 10 }}>
        <h3 style={{ margin: 0 }}>Published Posts ({posts.length})</h3>
        {posts.length > 0 && isSuperAdmin() &&  (
          <button
            className="btn btn-outline"
            style={{ padding: '5px 12px', fontSize: '0.8rem', borderColor: '#ef4444', color: '#ef4444' }}
            onClick={async function() {
              if (!window.confirm('Delete ALL ' + posts.length + ' posts? This cannot be undone.')) return;
              await Promise.all(posts.map(function(p) { return api.delete('/blog/' + p._id); }));
              load();
            }}
          >
            🗑 Delete All
          </button>
        )}
      </div>

      {/* Select all checkbox */}
      {posts.length > 0 && isSuperAdmin() &&(
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12, padding: '8px 0', borderBottom: '1px solid var(--bj-sand)' }}>
          <input
            type="checkbox"
            id="blog-select-all"
            style={{ accentColor: 'var(--bj-clay)', width: 16, height: 16 }}
            onChange={function(e) {
              if (e.target.checked) {
                setBlogChecked(posts.map(function(p) { return p._id; }));
              } else {
                setBlogChecked([]);
              }
            }}
            checked={blogChecked.length === posts.length && posts.length > 0}
          />
          <label htmlFor="blog-select-all" style={{ fontSize: '0.85rem', fontWeight: 600, cursor: 'pointer' }}>
            Select all
          </label>
          {blogChecked.length > 0 && isSuperAdmin() &&(
            <button
              className="btn btn-outline"
              style={{ marginLeft: 'auto', padding: '4px 12px', fontSize: '0.8rem', borderColor: '#ef4444', color: '#ef4444' }}
              onClick={async function() {
                if (!window.confirm('Delete ' + blogChecked.length + ' selected posts?')) return;
                await Promise.all(blogChecked.map(function(id) { return api.delete('/blog/' + id); }));
                setBlogChecked([]);
                load();
              }}
            >
              Delete Selected ({blogChecked.length})
            </button>
          )}
        </div>
      )}

      {posts.length === 0 && <p style={{ opacity: 0.6 }}>No posts yet.</p>}
      {posts.map(function(p) {
        return (
          <div key={p._id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 0', borderBottom: '1px solid var(--bj-sand)' }}>
            <input
              type="checkbox"
              checked={blogChecked.includes(p._id)}
              onChange={function() {
                setBlogChecked(function(prev) {
                  return prev.includes(p._id) ? prev.filter(function(x) { return x !== p._id; }) : [...prev, p._id];
                });
              }}
              style={{ accentColor: 'var(--bj-clay)', width: 16, height: 16, flexShrink: 0 }}
            />
            <div style={{ minWidth: 0, flex: 1 }}>
              <p style={{ margin: 0, fontWeight: 600, fontSize: '0.9rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.title}</p>
              <p style={{ margin: 0, fontSize: '0.78rem', opacity: 0.6 }}>{p.category} · {p.views} views</p>
            </div>
            <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
              <button className="btn btn-outline" style={{ padding: '4px 10px', fontSize: '0.8rem' }} onClick={function() { startEdit(p._id); }}>Edit</button>
               {isSuperAdmin() && (<button className="btn btn-outline" style={{ padding: '4px 10px', fontSize: '0.8rem', borderColor: '#ef4444', color: '#ef4444' }} onClick={function() { remove(p._id); }}>Delete</button>)}
            </div>
          </div>
        );
      })}
    </div>
  );

  return (
    <AdminLayout>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
        <h1 style={{ margin: 0, fontSize: 'clamp(1.4rem, 4vw, 2rem)' }}>Blog Posts</h1>
        {/* Mobile tab switcher */}
        <div style={{ display: 'flex', gap: 8 }}>
          <button
            className={tab === 'list' ? 'btn btn-primary' : 'btn btn-outline'}
            style={{ padding: '7px 14px', fontSize: '0.85rem' }}
            onClick={function() { setTab('list'); }}
          >Posts</button>
          <button
            className={tab === 'form' ? 'btn btn-primary' : 'btn btn-outline'}
            style={{ padding: '7px 14px', fontSize: '0.85rem' }}
            onClick={function() { setTab('form'); }}
          >+ New Post</button>
        </div>
      </div>

      {/* Desktop: side by side. Mobile: tabbed */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 24 }} className="desktop-only">
        {formPanel}
        {listPanel}
      </div>
      <div className="mobile-only" style={{ display: 'block' }}>
        {tab === 'form' ? formPanel : listPanel}
      </div>
    </AdminLayout>
  );
}